import React from 'react';
import { FieldComponent } from '@jutro/components';

export class CustomInputField extends FieldComponent {
    static propTypes = {
        ...FieldComponent.propTypes
    };

    static defaultProps = {
        ...FieldComponent.defaultProps
    };

    /**
     * Render control for this component.
     *
     * @param {object} breakpointProps - breakpoint-specific props
     *
     * @returns {React.ReactElement} JSX for the control
     */
    renderControlReadOnly(breakpointProps) {
        const {
            children
        } = breakpointProps;

        const child = Array.isArray(children) ? children[0] : children;
        return (
            <React.Fragment>
                {child}
            </React.Fragment>
        );
    }
}
